module.exports = "/virtual-football-league/img/amblems/left/logos/Reb.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/virtual-football-league/img/amblems/left/logos/Reb.png
// module id = 2119
// module chunks = 4